export const SETOCRSRSULT = 'SETOCRSRSULT'
export const SETOCRIMAGEBASE64 = 'SETOCRIMAGEBASE64'
export const SETIMAGEURL = 'SETIMAGEURL'
export const SETCUTSTYLEDISPLAY = 'SETCUTSTYLEDISPLAY'
export const SETCUTSTYLEPROCESS = 'SETCUTSTYLEPROCESS'
export const SETUPLOADBASE64 = 'SETUPLOADBASE64'
export const RESETDATA = 'RESETDATA'
export const SETOCRREGIONS = 'SETOCRREGIONS'
export const SETOCRPAGEDATA = 'SETOCRPAGEDATA'
export const SETPRPEDITEDDATA = 'SETPRPEDITEDDATA'
export const SETPICLANGUAGE = 'SETPICLANGUAGE'
export const SETFLOWNUMBER = 'SETFLOWNUMBER'
export const SETSTEP = 'SETSTEP'
export const SETSENSITIVEWORDS = 'SETSENSITIVEWORDS'



// WEBPACK FOOTER //
// ./src/store/mutation-type.js